import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ConvertUnit from "../../../../components/Math/Conversion/ConvertUnit";
import Foot from "../../../../components/Math/Units/Imperial/Foot";
import Metre from "../../../../components/Math/Units/Metric/Metre";
import { NumberFormatText } from "../../../../components/NumberFormatText";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { selectTotalLength } from "../../../../store/slices/aashtoSlice";

function TotalLength() {
  const { t } = useTranslation("translation");

  const totalLength = useSelector(selectTotalLength);

  return (
    <RowBody
      titleValue={<p>{t("aashto.ausser.Total Length")}</p>}
      inputValue={
        <span className="input">
          <NumberFormatText prefix="INF" value={totalLength.current} decimalScale={2} />
        </span>
      }
      unitValue={<ConvertUnit Metric={<Metre />} Imperial={<Foot />} />}
    />
  );
}

export default TotalLength;
